import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import { mockPrompts } from "../constants/prompts.mjs";
export const mockPromptResolver = (query, _) => {
  const resolved = mockPrompts.get(query.toLowerCase().trim());
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (resolved) {
        resolve(resolved);
      } else {
        console.error(`Unsupported query: ${query}`);
        reject(new Error(process.env.NODE_ENV !== "production" ? 'MUI X: Could not process prompt' : _formatErrorMessage(109)));
      }
    }, 1000);
  });
};